import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/scale.svg
 */
const IconScale: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 13.5v9h9v-9h-9zM.5 12a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5H.5z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.5 1.5v21h21v-21h-21zM.5 0a.5.5 0 00-.5.5v23a.5.5 0 00.5.5h23a.5.5 0 00.5-.5V.5a.5.5 0 00-.5-.5H.5z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.516 10.424l7.721-7.72 1.06 1.06-7.72 7.72a.75.75 0 01-1.06-1.06z"
      fill="currentColor"
    />
    <path
      d="M21.113 2.496a.4.4 0 01.433.433l-.4 4.66a.4.4 0 01-.681.248l-4.26-4.26a.4.4 0 01.248-.682l4.66-.4z"
      fill="currentColor"
    />
  </svg>
);

export default IconScale;
